import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-a6fe94c8"),n=n(),_popScopeId(),n)
const _hoisted_1 = { key: 1 }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fas fa-pen" }, null, -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!
  const _component_cheap = _resolveComponent("cheap")!
  const _component_new_button = _resolveComponent("new-button")!

  return (_ctx.column.key === 'index')
    ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
        _createTextVNode(_toDisplayString(_ctx.index + 1), 1)
      ], 64))
    : (_ctx.column.key === 'number')
      ? (_openBlock(), _createBlock(_component_router_link, {
          key: 1,
          class: "TripsLink",
          to: `/tms/ttns/${_ctx.row.id}`,
          target: "_blank"
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(_ctx.row.number), 1)
          ]),
          _: 1
        }, 8, ["to"]))
      : (_ctx.isDirection)
        ? (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
            _createTextVNode(_toDisplayString(_ctx.row.fromCity.name) + " - " + _toDisplayString(_ctx.row.toCity.name), 1)
          ], 64))
        : (_ctx.column.key === 'createdAt')
          ? (_openBlock(), _createElementBlock(_Fragment, { key: 3 }, [
              _createTextVNode(_toDisplayString(_ctx.formatDateWithTimeFromBackend(_ctx.row.createdAt)), 1)
            ], 64))
          : (_ctx.column.key === 'expectedDate')
            ? (_openBlock(), _createElementBlock(_Fragment, { key: 4 }, [
                _createTextVNode(_toDisplayString(_ctx.formatDateWithTimeFromBackend(_ctx.row.expectedDate)), 1)
              ], 64))
            : (_ctx.column.key === 'expectedDateWithSla')
              ? (_openBlock(), _createElementBlock(_Fragment, { key: 5 }, [
                  _createTextVNode(_toDisplayString(_ctx.formatDateWithTimeFromBackend(_ctx.row.expectedDateWithSla)), 1)
                ], 64))
              : (_ctx.column.key === 'arrivalDate')
                ? (_openBlock(), _createElementBlock(_Fragment, { key: 6 }, [
                    _createTextVNode(_toDisplayString(_ctx.formatDateWithTimeFromBackend(_ctx.row.arrivalDate)), 1)
                  ], 64))
                : (_ctx.column.key === 'status')
                  ? (_openBlock(), _createElementBlock(_Fragment, { key: 7 }, [
                      (_ctx.row.status)
                        ? (_openBlock(), _createBlock(_component_cheap, {
                            key: 0,
                            class: _normalizeClass(_ctx.getCheapClass)
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString(_ctx.getCheapTitle), 1)
                            ]),
                            _: 1
                          }, 8, ["class"]))
                        : (_openBlock(), _createElementBlock("span", _hoisted_1, " - "))
                    ], 64))
                  : (_ctx.column.key === 'actions')
                    ? (_openBlock(), _createElementBlock(_Fragment, { key: 8 }, [
                        (_ctx.row.status && (_ctx.row.status.id === 1 || _ctx.row.status.id === 3 || _ctx.row.isDelayed))
                          ? (_openBlock(), _createBlock(_component_new_button, {
                              key: 0,
                              class: "NewButton--small",
                              type: "button",
                              onClick: _ctx.onUpdate
                            }, {
                              default: _withCtx(() => [
                                _hoisted_2
                              ]),
                              _: 1
                            }, 8, ["onClick"]))
                          : _createCommentVNode("", true)
                      ], 64))
                    : (_openBlock(), _createElementBlock(_Fragment, { key: 9 }, [
                        _createTextVNode(_toDisplayString(_ctx.row[_ctx.column.key] || '-'), 1)
                      ], 64))
}